const seturlParams = (state, param) => {
  if (state === '') {
    return '';
  }

  return `&${param}=${state}`;
};

export default seturlParams;
